// Copyright (C) 2025 by Provatrix GmbH. All Rights reserved.

import { type useRoute } from 'vue-router';

type RouteType = ReturnType<typeof useRoute>;

export const getSingleRouteParamValueOrUndefined = (
  route: RouteType,
  id: string,
) => {
  const values = route.params[id];
  if (!values) return undefined;

  const value = Array.isArray(values) ? values[0] : values;
  if (!value) return undefined;

  return value;
};

export const getSingleRouteParamValue = (
  route: RouteType,
  id: string,
  defaultValue: string = '',
) => {
  return getSingleRouteParamValueOrUndefined(route, id) ?? defaultValue;
};

export const getSingleQueryParamValueOrUndefined = (
  route: RouteType,
  id: string,
) => {
  const values = route.query[id];
  if (!values) return undefined;

  const value = Array.isArray(values) ? values[0] : values;
  if (!value) return undefined;

  return value;
};

export const getSingleQueryParamValue = (
  route: RouteType,
  id: string,
  defaultValue: string = '',
) => {
  return getSingleQueryParamValueOrUndefined(route, id) ?? defaultValue;
};
